import React, { Component, PropTypes } from 'react';
// import axios from 'axios';

import Header from '../components/shared/Header';
import Footer from '../components/shared/Footer';
import BackToTop from '../components/shared/BackToTop';

// eslint-disable-next-line
class App extends Component {

  render() {
    return (
      <section>
        <Header />
        <main className="main">
          {this.props.children}
        </main>
        <Footer />
        <BackToTop />
      </section>
    );
  }
}

App.propTypes = {
  children: PropTypes.object.isRequired // eslint-disable-line
};

export default App;



// WEBPACK FOOTER //
// ./client/js/containers/App.js